// ported from https://github.com/vuejs/vue-next/blob/master/packages/runtime-core/src/apiWatch.ts by Evan You
import { isReactive, isRef, ReactiveEffect, } from '@vue/reactivity';
import { hasChanged, isArray, isFunction, isMap, isObject, isPlainObject, isSet, NOOP, } from '@vue/shared';
import { callWithAsyncErrorHandling, callWithErrorHandling, warn } from './errorHandling';
var invoke = function (fn) { return fn(); };
var INITIAL_WATCHER_VALUE = {};
// Simple effect.
export function watchEffect(effect, options) {
    return doWatch(effect, null, options);
}
// implementation
export function watch(source, cb, options) {
    return doWatch(source, cb, options);
}
function doWatch(source, cb, _a) {
    var _b = _a === void 0 ? {} : _a, immediate = _b.immediate, deep = _b.deep;
    var getter;
    if (isArray(source) && !isReactive(source)) {
        getter = function () {
            // eslint-disable-next-line array-callback-return
            return source.map(function (s) {
                if (isRef(s))
                    return s.value;
                else if (isReactive(s))
                    return traverse(s);
                else if (isFunction(s))
                    return callWithErrorHandling(s, 'watch getter');
                else
                    warn('invalid source');
            });
        };
    }
    else if (isRef(source)) {
        getter = function () { return source.value; };
    }
    else if (isReactive(source)) {
        getter = function () { return source; };
        deep = true;
    }
    else if (isFunction(source)) {
        if (cb) {
            // getter with cb
            getter = function () { return callWithErrorHandling(source, 'watch getter'); };
        }
        else {
            // no cb -> simple effect
            getter = function () {
                if (cleanup)
                    cleanup();
                return callWithErrorHandling(source, 'watch callback', [onInvalidate]);
            };
        }
    }
    else {
        getter = NOOP;
    }
    if (cb && deep) {
        var baseGetter_1 = getter;
        getter = function () { return traverse(baseGetter_1()); };
    }
    var cleanup;
    var onInvalidate = function (fn) {
        cleanup = effect.onStop = function () {
            callWithErrorHandling(fn, 'watch cleanup');
        };
    };
    var oldValue = isArray(source) ? [] : INITIAL_WATCHER_VALUE;
    var job = function () {
        if (cb) {
            var newValue = effect.run();
            if (deep || hasChanged(newValue, oldValue)) {
                // cleanup before running cb again
                if (cleanup)
                    cleanup();
                callWithAsyncErrorHandling(cb, 'watch callback', [
                    newValue,
                    // pass undefined as the old value when it's changed for the first time
                    oldValue === INITIAL_WATCHER_VALUE ? undefined : oldValue,
                    onInvalidate,
                ]);
                oldValue = newValue;
            }
        }
        else {
            // watchEffect
            effect.run();
        }
        // cb ? () => {
        //     }
        //   }
        //   :
        // undefined
    };
    var scheduler = job;
    // if (flush === 'sync') {
    //   scheduler = job as any; // the scheduler function gets called directly
    // }
    // // else if (flush === 'post') {
    // //   scheduler = () => queuePostRenderEffect(job, instance && instance.suspense)
    // // }
    // else {
    //   // default: 'pre'
    //   // 调度器实现
    //   const queue: Function[] = [];
    //   let isFlushing = false;
    //   scheduler = () => {
    //     if (!queue.includes(job)) queue.push(job);
    //     if (!isFlushing) {
    //       isFlushing = true;
    //       Promise.resolve().then(() => {
    //         let fn;
    //         try {
    //           while ((fn = queue.shift())) {
    //             fn();
    //           }
    //         } finally {
    //           isFlushing = false;
    //         }
    //       });
    //     }
    //   };
    // }
    // const runner = effect(getter, {
    //   lazy: true,
    //   onTrack,
    //   onTrigger,
    //   // scheduler: applyCb ? () => scheduler(applyCb) : scheduler,
    // });
    var effect = new ReactiveEffect(getter, scheduler);
    // initial run
    if (cb) {
        if (immediate) {
            job();
        }
        else {
            oldValue = effect.run();
        }
    }
    else {
        effect.run();
    }
    return function () {
        effect.stop();
    };
}
var ReactiveFlags;
(function (ReactiveFlags) {
    ReactiveFlags["SKIP"] = "__v_skip";
    ReactiveFlags["IS_REACTIVE"] = "__v_isReactive";
    ReactiveFlags["IS_READONLY"] = "__v_isReadonly";
    ReactiveFlags["RAW"] = "__v_raw";
})(ReactiveFlags || (ReactiveFlags = {}));
function traverse(value, seen) {
    if (seen === void 0) { seen = new Set(); }
    if (!isObject(value) || value["__v_skip" /* SKIP */]) {
        return value;
    }
    seen = seen || new Set();
    if (seen.has(value)) {
        return value;
    }
    seen.add(value);
    if (isRef(value)) {
        traverse(value.value, seen);
    }
    else if (isArray(value)) {
        for (var i = 0; i < value.length; i++) {
            traverse(value[i], seen);
        }
    }
    else if (isSet(value) || isMap(value)) {
        value.forEach(function (v) {
            traverse(v, seen);
        });
    }
    else if (isPlainObject(value)) {
        for (var key in value) {
            traverse(value[key], seen);
        }
    }
    return value;
}
